<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            {{ hospitalName }} - COVID-19 Data Dashboard:
          </h4>
          <Breadcrumbs
            v-if="activeHospital"
            :breadcrumbs="[
              { title: 'Dashboards', to: `/dashboard/${activeHospital}` },
              { title: 'Victorian Dashboard', to: '/dashboards/victoria' }
            ]"
          />

          <p class="mt-2">Data sourced and maintained by {{ hospitalName }}.</p>
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 "
      >
        <vx-card :title="`${hospitalName} Number of Calls:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.numberOfCalls"
            :loading="hospitalData.loading"
          />
        </vx-card>
        <vx-card :title="`${hospitalName} Number of Patients Tested:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.patientsTested"
            :loading="hospitalData.loading"
          />
        </vx-card>
        <vx-card :title="`${hospitalName} Positive Patient Tests:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.positivePatientTests"
            :loading="hospitalData.loading"
          />
        </vx-card>
        <vx-card :title="`${hospitalName} Negative Patient Tests:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.negativePatientTests"
            :loading="hospitalData.loading"
          />
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card :title="`${hospitalName} - Admissions, Suspected COVID :`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.patientsAdmitted"
            :loading="hospitalData.loading"
          />
        </vx-card>
        <vx-card :title="`${hospitalName} - Ward Beds, Suspected COVID:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.wardBedsConsumed"
            :loading="hospitalData.loading"
          />
        </vx-card>
        <vx-card :title="`${hospitalName} - ICU Beds, Suspected COVID:`">
          <GraphTile
            v-if="!hospitalData.loading"
            :date-range="hospitalData.dateRange"
            :data-set="hospitalData.dataSets.icuBedsConsumed"
            :loading="hospitalData.loading"
          />
        </vx-card>
      </div>
    </div>
    <FetchHospitalData :hospital-name="hospitalName" v-model="hospitalData" />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import FetchHospitalData from "@/modules/dashboard/components/FetchHospitalData";
import GraphTile from "@/modules/dashboard/components/dashboard-cards/GraphTile";
import { mapState } from "vuex";

export default {
  name: "HospitalDashboard",
  components: {
    Breadcrumbs,
    FetchHospitalData,
    GraphTile
  },
  data() {
    return {
      hospitalData: {
        dataSets: {
          numberOfCalls: [],
          patientsTested: [],
          positivePatientTests: [],
          negativePatientTests: [],
          patientsAdmitted: [],
          wardBedsConsumed: [],
          icuBedsConsumed: []
        },
        dateRange: [],
        loading: true
      }
    };
  },
  computed: {
    ...mapState(["activeHospital"]),
    hospitalName() {
      return this.$route.params.id;
    }
  },
  setActiveHospital() {
    this.$store.dispatch("updateActiveHospital", this.hospitalName);
  }
};
</script>

<style scoped>
.breadcrumb {
  color: #7367f0;
}
</style>
